import React, { useEffect, useState } from "react";
import AnimatedContent from "../common/AnimatedContent";
import PageTitle from "../common/PageTitle";
import MeetingRequestTable from "../Components/meetingRequest/MeetingRequestTable";
import Images from "../constant/Images";
import {
  handleGetAllMeetingRequests,
  handleApprovedMeeingRequest,
  handleRejectMeetingRequest,
} from "../services/routes/meetingRequestRoute";
import Drawer from "../common/Drawer";
import LabelArea from "../Components/form/Label/LabelArea";
import { AiOutlineUser } from "react-icons/ai";
import { LuPhone } from "react-icons/lu";
import { FaEnvelope } from "react-icons/fa";
import { userID } from "../utils/storage";
import { RiErrorWarningLine } from "react-icons/ri";
import ListModel from "../common/ListModel";
import { handleGetRoleBasedUsers } from "../services/userService";
import { notifySuccess } from "../utils/toast";
import Loading from "../common/Loading";

const MeetingRequest = () => {
  const [visible, setVisible] = useState(false);
  const [meetingData, setMeetingData] = useState([]);
  const [selectedMeetingInfo, setSelectedMeetingInfo] = useState({});
  const [selectedRequestStatus, setSelectedRequestStatus] = useState("PENDING");
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [nextId, setNextId] = useState("");
  const [prevId, setPrevId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [openModel, setOpenModel] = useState(false);
  const [isListModelOpen, setIsListModelOpen] = useState(false);
  const [presonList, setPresonList] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [meetingCache, setMeetingCache] = useState(new Map());
  const [loader , setLoader] = useState(false);
  const [hasMore , setHasMore] = useState(false);

  const handlePresonList = async () => {
    try {
      const response = await handleGetRoleBasedUsers();
      setPresonList(response);
    } catch (error) {
      console.error("Error fetching person list:", error);
    }
  };

  useEffect(() => {
    if (isListModelOpen) handlePresonList();
  }, [isListModelOpen]);

  const fetchMeetingRequest = async (
    direction = null,
    pageNumber = currentPage
  ) => {
    if (direction === "previous" && meetingCache.has(pageNumber)) {
      setMeetingData(meetingCache.get(pageNumber));
      return;
    }

    setLoading(true);
    setMeetingData([]);
    try {
      const body = {
        limitCount: limit,
        searchKey: "",
        startDate: "",
        endDate: "",
        startAfterDoc:
          direction === "next"
            ? nextId
            : direction === "previous"
            ? prevId
            : null,
        status: selectedRequestStatus,
      };

      console.log("Meeting payload  ", body);

      const response = await handleGetAllMeetingRequests(body);
      const data = response?.response || [];

      console.log("Meeting Request response:", response);
      const receivedFullPage = data.length === limit;
      const hasMoreData = receivedFullPage && !!response.lastDoc;
      setHasMore(hasMoreData)

      console.log("hasMoreData" , hasMoreData)

      setMeetingData(data);
      setNextId(response?.lastDoc || "");
      setPrevId(response?.firstDoc || "");

      setMeetingCache((prev) => {
        const newCache = new Map(prev);
        newCache.set(pageNumber, data);
        return newCache;
      });
    } catch (error) {
      console.error("Error fetching meeting requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setMeetingCache(new Map());
    setCurrentPage(1);
    fetchMeetingRequest();
  }, [selectedRequestStatus, limit]);

  const handlePageChange = (token, direction) => {
    console.log("Direction :", direction);
    if (direction === "next") {
      const nextPage = currentPage + 1;
      if (meetingCache.has(nextPage)) {
        setMeetingData(meetingCache.get(nextPage));
        setCurrentPage(nextPage);
      } else {
        fetchMeetingRequest("next", nextPage);
        setCurrentPage(nextPage);
      }
    } else if (direction === "previous") {
      const prevPage = currentPage - 1;
      if (meetingCache.has(prevPage)) {
        setMeetingData(meetingCache.get(prevPage));
        const nextPageData = meetingCache.get(prevPage + 0 );
        console.log(nextPageData)
        setHasMore(!!nextPageData && nextPageData.length >= limit);
      }
      setCurrentPage(prevPage);
    }
  };

  const handlePageSize = (value) => {
    setLimit(value);
    setMeetingCache(new Map());
    setCurrentPage(1);
  };

  const handleTabChange = (status) => {
    setSelectedRequestStatus(status);
    setCurrentPage(1);
    setNextId("");
    setPrevId("");
  };

  const handleRejectMeeting = async () => {

    try {
      const response = await handleRejectMeetingRequest(
        selectedMeetingInfo.id,
        userID
      );
      notifySuccess(response?.message);
      setOpenModel(false);
      fetchMeetingRequest();
    } catch (error) {
      console.error("Error rejecting meeting request:", error);
    }
  };

  const handleAssignMeetingRequest = async (meetingId, id) => {
    
    try {
      const response = await handleApprovedMeeingRequest(
        selectedMeetingInfo.id,
        userID,
        id
      );
      setLoader(true)
      setIsListModelOpen(false);
      notifySuccess(response.message);
      setSelectedId("")
      fetchMeetingRequest();
    } catch (error) {
      console.error("Error assigning meeting request:", error);
    }finally{
      setLoader(false)
    }
  };

  const columns = [
    {
      key: "Name",
      title: "Name",
      render: (text, record) => (
        <div title={text} className="text-center truncate">
          {record.name.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="text-center">
          {record?.countryCode + " " + record.phoneNumber}
        </div>
      ),
    },
    {
      key: "emailId",
      title: "Email ID",
      render: (text) => <div className="text-center">{text}</div>,
    },
    {
      key: "createdDate",
      title: "Created Date",
      render: (text) => <div className="text-center">{text}</div>,
    },
    {
      key: "action",
      title: "Action",
      render: (text, record) => (
        <div className="flex justify-center gap-2">
          <img
            onClick={() => {
              setSelectedMeetingInfo(record);
              setVisible(true);
            }}
            src={Images.eyeIcon}
            className="w-5 h-5 cursor-pointer"
            alt="View"
          />
          {selectedRequestStatus === "PENDING" && (
            <>
              <img
                onClick={() => {
                  setSelectedMeetingInfo(record);
                  setIsListModelOpen(true);
                }}
                src={Images.sendIcon}
                className="w-5 h-5 cursor-pointer"
                alt="Send"
              />
              <img
                onClick={() => {
                  setSelectedMeetingInfo(record);
                  setOpenModel(true);
                }}
                src={Images.cancelIcon}
                className="w-5 h-5 cursor-pointer"
                alt="Cancel"
              />
            </>
          )}

         
          
        </div>
      ),
    },
  ];

  return (
    <div>
     {loader &&(
        <Loading/>
      )}
      <AnimatedContent>
        <div className="flex justify-between mb-5">
          <PageTitle title="Meeting Request" />
        </div>

        <div className="flex gap-4 mb-4">
          {["PENDING", "APPROVED", "REJECTED"].map((status) => (
            <div
              key={status}
              className={`px-4 py-2 rounded-full bg-white cursor-pointer ${
                selectedRequestStatus === status
                  ? "border-2 border-primary text-primary"
                  : "border-2"
              }`}
              onClick={() => handleTabChange(status)}
            >
              {status.charAt(0) + status.slice(1).toLowerCase()}
            </div>
          ))}
        </div>

        <MeetingRequestTable
          columns={columns}
          data={meetingData}
          loading={loading}
          limit={limit}
          currentPage={currentPage}
          nextId={nextId}
          prevId={prevId}
          handlePageChange={handlePageChange}
          handlePageSize={handlePageSize}
          hasMore ={hasMore}
        />
      </AnimatedContent>

      <Drawer
        open={visible}
        onClose={() => setVisible(false)}
        title="Request Info"
      >
        <div className="flex flex-col gap-5">
          <LabelArea
            label={
              <div className="flex gap-2 items-center">
                <div className="text-white bg-blue-300 p-2 rounded-full">
                  <AiOutlineUser className="text-white text-base " />{" "}
                </div>
                Name
              </div>
            }
          />
          <input
            value={selectedMeetingInfo.name || ""}
            disabled
            className="border p-3 rounded-lg"
          />
          <LabelArea
            label={
              <div className="flex gap-2 items-center">
                <div className="bg-green-300 p-2 rounded-full">
                  <LuPhone className="text-white text-base" />
                </div>
                Phone Number
              </div>
            }
          />

          <input
            value={selectedMeetingInfo.phoneNumber || ""}
            disabled
            className="border p-3 rounded-lg"
          />
          <LabelArea
            label={
              <div className="flex gap-2 items-center">
                <div className="text-white bg-blue-300 p-2 rounded-full">
                  <FaEnvelope className="text-white text-base " />{" "}
                </div>
                Email
              </div>
            }
          />
          <input
            value={selectedMeetingInfo.emailId || ""}
            disabled
            className="border p-3 rounded-lg"
          />
          <LabelArea label={<span>Reason for Meeting</span>} />
          <textarea
            value={selectedMeetingInfo.meetingReason || ""}
            disabled
            rows="7"
            maxLength={350}
            className="border p-3 rounded-lg"
          />
        </div>
      </Drawer>

      {openModel && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl w-[554px] shadow-xl">
            <div className="text-center">
              <RiErrorWarningLine className="text-[30px] text-orange-600 mx-auto" />
              <p className="text-xl font-semibold mt-4">Are You Sure?</p>
              <p className="text-base mt-2">
                Are you sure you want to Reject Meeting Request?
              </p>
            </div>
            <div className="flex justify-center gap-6 mt-6">
              <button
                onClick={() => setOpenModel(false)}
                className="bg-gray-400 rounded-lg w-[134px] h-[42px] text-white"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectMeeting}
                className="bg-primary rounded-lg w-[134px] h-[42px] text-white"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

      <ListModel
        open={isListModelOpen}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        onSubmit={handleAssignMeetingRequest}
        data={presonList}
        onClose={() => {
          setIsListModelOpen(false)
          setSelectedId("")
        }
        }
        isResign={true}
      />
    </div>
  );
};

export default MeetingRequest;